import { defineMessages } from 'react-intl'

export interface facetMessage {
  id: string
  defaultMessage: string
}

export const cooAndCoaMessages = defineMessages({
  COO_INSTRUCTIONS: {
    id: 'COO_INSTRUCTIONS',
    defaultMessage:
      'To search for a Certificate of Origin (COO), please enter both the product number and the lot/batch number.',
  },
  COO_NOT_FOUND: { id: 'COO_NOT_FOUND', defaultMessage: 'COO Not Found' },
  COO_NOT_FOUND_INSTRUCTIONS: {
    id: 'COO_NOT_FOUND_INSTRUCTIONS',
    defaultMessage:
      'In some cases, a COO may not be available online. If your search was unable to find the COO you can {requestACooLink}. In many cases a COO can be faxed to you upon submission of this form.',
  },
  COO_PROD_NO: { id: 'PROD_NO', defaultMessage: 'Product Number:' },
  COO_LOT_NO: { id: 'LOT_NO', defaultMessage: 'Lot Number:' },
  COO_PROD_DESC: { id: 'PROD_DESC', defaultMessage: 'Product Name:' },
  COO_NOANIMALWAYS: {
    id: 'NOANIMALWAYS',
    defaultMessage: 'Always non-animal source?',
  },
  COO_PRODTYPE: { id: 'PRODTYPE', defaultMessage: 'Type of Manufacture:' },
  COO_SUBTYPE: { id: 'SUBTYPE', defaultMessage: 'Sub-Type' },
  COO_SUBTYPENOTES: {
    id: 'SUBTYPENOTES',
    defaultMessage: 'Notes/Species/Description:',
  },
  COO_PLANT: { id: 'PLANT', defaultMessage: 'Plant Species:' },
  COO_ANIMAL: { id: 'ANIMAL', defaultMessage: 'Animal Species:' },
  COO_OTHERSOURCE: { id: 'OTHERSOURCE', defaultMessage: 'Description:' },
  COO_MICRO: { id: 'MICRO', defaultMessage: 'Microbial Species:' },
  COO_RECOM: { id: 'RECOM', defaultMessage: 'Recombinant Species:' },
  COO_CHEMANIMAL: {
    id: 'CHEMANIMAL',
    defaultMessage: 'Does processing contain any animal components?',
  },
  COO_AMINFERM: {
    id: 'AMINFERM',
    defaultMessage:
      'Does the fermentation process contain any animal components?',
  },
  COO_TISSUE_USED: { id: 'TISSUE_USED', defaultMessage: 'Tissue Used:' },
  COO_CNTRY_ORGN: {
    id: 'CNTRY_ORGN',
    defaultMessage: 'Material Country of Origin:',
  },
  COO_ANIMCOUNTRY: {
    id: 'ANIMCOUNTRY',
    defaultMessage: 'Country of Origin of Biological Components:',
  },
  COO_SITE_MNFCTR: {
    id: 'SITE_MNFCTR',
    defaultMessage: 'Country of Manufacture:',
  },
  COO_CERTTYPE: { id: 'CERTTYPE', defaultMessage: 'Type of Certification:' },
  COO_GMP_ISO: { id: 'GMP_ISO', defaultMessage: 'Certification Number:' },
  COO_COOFILED: {
    id: 'COOFILED',
    defaultMessage:
      'Has a certificate of suitability been filed for TSE (Transmissable Spongiform Encephalopathies):',
  },
  COO_COONUMBER: {
    id: 'COONUMBER',
    defaultMessage: 'If yes, what is the certificate number?',
  },
  COO_EU_LEVEL: { id: 'EU_LEVEL', defaultMessage: 'EU Infectivity Level:' },
  COO_USDAEQUIV: {
    id: 'USDAEQUIV',
    defaultMessage:
      'Animals obtained from USDA  (United States Department of Agriculture) or Foreign Government Facilities?',
  },
  COO_TRACE_FCLTY_NEW: {
    id: 'TRACE_FCLTY_NEW',
    defaultMessage: 'If yes, then indicate USDA or equivalent site number?',
  },
  COO_ANIMTRACEFACILITY: {
    id: 'ANIMTRACEFACILITY',
    defaultMessage:
      'Are the animal(s) tracable back to the processing facility?',
  },
  COO_INACT_VIRAL: {
    id: 'INACT_VIRAL',
    defaultMessage: 'Process performed to inactivate pathogenic viral agents',
  },
  COO_COMINGLE: {
    id: 'COMINGLE',
    defaultMessage: 'Is there any comingling with other animal materials?',
  },
  COO_COMINGLEDESCR: {
    id: 'COMINGLEDESCR',
    defaultMessage: 'If yes, please describe:',
  },
  COO_VIRUS_FREE: {
    id: 'VIRUS_FREE',
    defaultMessage: 'Testing of product to prove virus free',
  },
  COO_PROTEIN: {
    id: 'PROTEIN',
    defaultMessage: 'Was animal protein fed to the animals?',
  },
  COO_RUMIN: {
    id: 'RUMIN',
    defaultMessage: 'Was ruminant protein fed to the animals?',
  },
  COO_ANIMAL_AGE: {
    id: 'ANIMAL_AGE',
    defaultMessage: 'Age of animal(s) at time of slaughter:',
  },
  COO_MTHD_SLGHTR: {
    id: 'MTHD_SLGHTR',
    defaultMessage: 'Method of Slaughter:',
  },
  COO_ANTE: {
    id: 'ANTE',
    defaultMessage: 'Did animal(s) pass ante and post mortem testing?',
  },
  COO_OTHERINFO: { id: 'OTHERINFO', defaultMessage: 'Comments:' },
  COO_SOURCE: { id: 'SOURCE', defaultMessage: 'Source' },
  COO_TYPE: { id: 'TYPE', defaultMessage: 'Type' },
  COO_SPECIES: { id: 'SPECIES', defaultMessage: 'Species' },
  COO_ANIMAL_CONT: {
    id: 'ANIMAL_CONT',
    defaultMessage: 'Facility / Animal Contamination',
  },
  COO_TRACE_FCLTY: {
    id: 'TRACE_FCLTY',
    defaultMessage: 'Tracable back to the processing facility:',
  },
  COO_ANIMAL_PROT: {
    id: 'ANIMAL_PROT',
    defaultMessage: 'Was animal protein fed to the animals?',
  },
  COO_RUMNT_PROT: {
    id: 'RUMNT_PROT',
    defaultMessage: 'Was ruminant protein fed to the animals?',
  },
  COO_MORTEM_TEST: {
    id: 'MORTEM_TEST',
    defaultMessage: 'Did Animals Pass Post and Anti-Mortem Test?',
  },
  COO_GOV_FAC: {
    id: 'GOV_FAC',
    defaultMessage:
      'Animals obtained from USDA or Foreign Government Facilities?',
  },
  COO_SHAREEQUIP: {
    id: 'SHAREEQUIP',
    defaultMessage: 'Is this manufactured in shared equipment?',
  },
  COO_SHAREEQUIPNOTE: {
    id: 'SHAREEQUIPNOTE',
    defaultMessage: 'If yes, please describe:',
  },
  COO_CLEANINGEQUIP: {
    id: 'CLEANINGEQUIP',
    defaultMessage: 'Is equipment cleaning between products validated?',
  },
  COO_CLEANINGEQUIPNOTE: {
    id: 'CLEANINGEQUIPNOTE',
    defaultMessage: 'If yes, please describe:',
  },
  COO_NURONAL: {
    id: 'NURONAL',
    defaultMessage: 'Does any component contain neuronal tissue?',
  },
  COA_NOT_FOUND: { id: 'COA_NOT_FOUND', defaultMessage: 'COA Not Found' },
  COA_NOT_FOUND_INSTRUCTIONS: {
    id: 'COA_NOT_FOUND_INSTRUCTIONS',
    defaultMessage:
      'In some cases, a COA may not be available online. If your search was unable to find the COA you can {requestACoaLink}. In many cases a COA can be faxed to you upon submission of this form.',
  },
})

export default cooAndCoaMessages
